import { Vector2 } from "three";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { PlotSettings } from "./PlotSettings";
import { CanvasDrawer } from "../../../library-js/dom/CanvasDrawer";
import { MathX } from "../../../library-js/math/MathX";

export class Plot
{
  static type = new ElementType( "plot-element" );

  _settings:PlotSettings;
  _plots:number[][];
  _element:Element;
  _canvasDrawer:CanvasDrawer;
  _visualizePoint:number;
  
  static  create( width:number, height:number ):Plot
  {
    let plot = new Plot();

    plot._element = Plot.type.create();
    let canvas = ElementType.canvas.create();
    canvas.width = width;
    canvas.height = height;

    plot._canvasDrawer = new CanvasDrawer( canvas );
    plot._element.appendChild( plot._canvasDrawer.canvas );

    return plot;
  }

  render()
  {
    this._canvasDrawer.fillBackground( this._settings.backgroundColor );

    for ( let i = 0; i < this._settings.lineSettings.length; i++ )
    {
      let lineColor = this._settings.lineSettings[ i ].lineColor;
      let lineWidth = this._settings.lineSettings[ i ].lineWidth || this._settings.lineWidthAll;

      this._canvasDrawer.setLineStyle( lineColor, lineWidth );
      this._canvasDrawer.drawPlotFromValues( this._plots[ i ], true, this._settings.min, this._settings.max );

    }

    for ( let i = 0; i < this._settings.lineSettings.length; i++ )
    {
      let lineColor = this._settings.lineSettings[ i ].lineColor;
      let lineWidth = this._settings.lineSettings[ i ].lineWidth || this._settings.lineWidthAll;

      this._canvasDrawer.setFillStyle( lineColor );
      this._canvasDrawer.setLineStyle( lineColor );

      let point = this._settings.visualizePoint;
      let pointIndex = Math.round( this._plots[ i ].length * point );
      pointIndex = MathX.clamp( pointIndex, 0, this._plots[ i ].length - 1 );

      let value = this._plots[ i ][ pointIndex ];

      let position = new Vector2( point, value );
      this._canvasDrawer.map( position, this._settings.min, this._settings.max );
      this._canvasDrawer.drawCircles( [ position ], 10 * lineWidth, new Vector2( 0, 0 ) );
    }



  }
}